import * as z from "zod";

export const getTags = {
  name: "getTags" as const,
  input: z.object({}),
  output: z.array(z.string()),
};
